<template>
  <div v-if="!uploading" class="js-upload uk-align-center" uk-form-custom>
    <input type="file" multiple @change="onFilePicked" />
    <button
      class="uk-button uk-button-default uk-width-1-1"
      type="button"
      tabindex="-1"
    >
      <span
        v-if="!uploading"
        class="uk-margin-small-right"
        uk-icon="upload"
      ></span
      >Upload Proofs
    </button>
  </div>
</template>

<script>
import firebase from "firebase";
import _ from "lodash";

export default {
  name: "AdminUpload",
  props: {
    firebaseId: { type: String, default: null },
    projectData: { type: Object, default: null }
  },
  data() {
    return {
      tempUploadedFiles: [],
      badExtension: false,
      uploading: false,
      uploadProgress: 0
    };
  },
  methods: {
    removeFile(index) {
      this.tempUploadedFiles.splice(index, 1);
    },

    onFilePicked(event) {
      var self = this;
      const files = event.target.files;
      for (let index = 0; index < files.length; index++) {
        const file = files[index];
        self.badExtension = false;
        let fileDeatils = {
          originalName: "",
          newName: "",
          extension: "",
          downloadURL: "",
          canPreview: false
        };
        let filename = file.name;
        fileDeatils.originalName = filename;
        if (filename.lastIndexOf(".") <= 0) {
          return alert("Please add a valid file!");
        }
        let filenameNoExtension = _.split(filename, ".")[0];
        let extension = _.split(filename, ".")[1];
        fileDeatils.extension = extension;

        if (!["png", "jpg"].includes(extension)) {
          self.badExtension = true;
          return;
        }

        //firebase example
        let storageRef = firebase.storage().ref();
        let newName =
          filenameNoExtension + _.random(10000, 99999) + "." + extension;
        fileDeatils.newName = newName;
        let imageRef = storageRef.child("proof-images/" + newName);
        let uploadTask = imageRef.put(file);
        // Listen for state changes, errors, and completion of the upload.
        uploadTask.on(
          firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
          function(snapshot) {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            let progress = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
            self.uploadProgress = progress * (index / files.length);
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                break;
              case firebase.storage.TaskState.RUNNING: // or 'running'
                self.uploading = true;
                break;
            }
          },
          function(error) {
            console.error(error.code);
          },
          function() {
            // Upload completed successfully, now we can get the download URL
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function(downloadURL) {
                if (index == files.length - 1) {
                  self.uploading = false;
                  self.uploadProgress = 0;
                }
                fileDeatils.downloadURL = downloadURL;
                self.pushNewProduct(fileDeatils, index);
                if (index == files.length - 1) {
                  self.$emit("files-uploaded", files.length);
                }
                //self.tempUploadedFiles.push(fileDeatils);
              });
          }
        );
      }
    },
    pushNewProduct(item) {
      let self = this;
      let product = {
        alerts: {
          lowContrast: false,
          lowRes: false,
          pantone: false,
          thinLines: false
        },
        created: new Date(Date.now()),
        customNotes: "",
        fileName: item.originalName,
        hidden: false,
        productType: "Necktie",
        proofID: _.split(item.originalName, ".")[0],
        proofImage: item.downloadURL
      };
      firebase
        .firestore()
        .collection("projects")
        .doc(self.firebaseId)
        .collection("products")
        .add(product)
        .then(function() {})
        .catch(function(error) {
          console.error("Error adding document: ", error);
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/AdminUpload.vue